export const includeQuery = "include=userReceiver;userSender;product.content.image";